<template>
    <div class="col-12 mb-2">
        <table-app
            ref="tabela"
            :data="relatorios"
            :columns="columns"
            :actions="actions"
            @open="open"
        />
    </div>
</template>
<script>
export default {
    props: [
        "relatorios",
        "meses",
        "anos",
        "periodos",
        "tipos",
        "tiposelected",
        "unidades",
    ],
    name: "Relatorios",
    data() {
        return {
            sortBy: "tipo",
            sortDesc: false,
            page: 1,
            search: "",
            perPage: 10,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            columns: [
                {
                    id: 1,
                    name: "tipo",
                    label: "Tipo",
                    filter: true,
                    search: true,
                    type: "select",
                    options: this.tipos,
                    checked: true,
                    align: "start",
                },
                {
                    id: 2,
                    label: "Período",
                    name: "periodo",
                    filter: true,
                    search: true,
                    type: "select",
                    options: this.periodos,
                    searchModel: "",
                    checked: true,
                },
                {
                    id: 3,
                    label: "Mês",
                    name: "mes_nome",
                    filter: true,
                    search: true,
                    type: "select",
                    searchModel: "",
                    checked: true,
                    options: this.meses,
                },
                {
                    id: 4,
                    label: "Ano",
                    name: "ano",
                    filter: true,
                    search: true,
                    type: "select",
                    searchModel: "",
                    checked: true,
                    options: this.anos,
                },
                {
                    id: 5,
                    label: "Unidade(s)",
                    name: "unidades_nome",
                    filter: true,
                    search: true,
                    type: "select",
                    searchModel: "",
                    align: "start",
                    checked: true,
                    options: this.unidades,
                },
                {
                    id: 6,
                    label: "Data",
                    name: "created_at",
                    filter: true,
                    search: true,
                    type: "data",
                    searchModel: "",
                    checked: true,
                },
            ],
            actions: [
                {
                    name: "Abrir",
                    label: "Abrir",
                    icon: "mdi mdi-square-edit-outline",
                    class: "px-2 mb-0 btn btn-sm btn-success",
                    emit: "open",
                },
            ],
        };
    },
    watch: {
        tiposelected() {
            this.setFiltro();
        },
    },
    mounted() {
        this.setFiltro();
    },
    methods: {
        setFiltro() {
            let tipo = this.tiposelected;
            if (this.tiposelected == "") {
                tipo = this.$route.query.tipo;
            }
            if (tipo != "") {
                this.$refs.tabela.searchColumn = "tipo";
                this.$refs.tabela.searchValue = tipo;
                this.$refs.tabela.searchColumnIndex = 0;
                this.$refs.tabela.statusFiltro = true;
            }
        },
        getMore() {},
        open(id) {
            let relatorio = this.relatorios.filter((r) => r.id == id);
            if (relatorio.length > 0) {
                this.$emit("open", relatorio[0]);
            }
        },
    },
};
</script>
